<template>
  <div id="merge">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员合并</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchList"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.merge"
          icon="iconfont icon-chuangjian1"
          @click="mergeVisibleDialog"
          >合并会员</el-button
        >
      </div>
    </div>
    <!-- 合并会员弹窗 -->
    <div class="merge">
      <el-dialog width="55%" title="合并会员" :visible.sync="mergeVisible">
        <div style="height: 30px; background-color: #ededed; line-height: 30px">
          <span style="margin-left: 20px; color: #6c6937">合并后会员</span>
        </div>
        <div style="margin: 0 20px 20px 20px">
          <!-- 弹窗表单 -->
          <div style="width: 450px; margin-top: 10px">
            <el-form size="mini" label-width="200px" :model="formInline">
              <el-form-item label="会员姓名\会员卡号\手机号">
                <div class="flex-between">
                  <el-input style="width: 300px" v-model="formInline.serach">
                  </el-input>
                  <el-button
                    style="
                      width: 80px;
                      margin-left: 10px;
                      background-color: #f1f1f1;
                      color: #b6b388;
                    "
                    size="small"
                    icon="el-icon-search"
                    @click="onSubmit1"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 弹窗列表 -->
          <div style="width: 100%; margin-top: 10px">
            <el-table
              size="mini"
              height="200"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
                fontSize: '12px',
              }"
              :cell-style="{ 'text-align': 'center', fontSize: '10px' }"
              ref="multipleTable"
              :data="tableData1"
              tooltip-effect="dark"
            >
              <el-table-column label width="35">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.$index"
                    v-model="radio1"
                    @change.native="getCurrentRow1(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column prop="custName" label="顾客姓名">
              </el-table-column>
              <el-table-column prop="cardNo" label="会员卡号">
              </el-table-column>
              <el-table-column prop="levelName" label="顾客等级">
              </el-table-column>
              <el-table-column prop="mobile" label="移动电话">
              </el-table-column>
              <el-table-column prop="serviceOrgCode" label="维护店">
              </el-table-column>
              <el-table-column prop="serviceEmpCode" label="当前维护人">
              </el-table-column>
              <el-table-column prop="custType" label="会员类型">
                <template slot-scope="scope">
                  {{ scope.row.custType === 0 ? "非VIC会员" : "VIC会员" }}
                </template>
              </el-table-column>
              <el-table-column prop="lastSaleDate" label="最近购买日">
              </el-table-column>
              <el-table-column prop="currYearAmount" label="今年消费金额">
              </el-table-column>
              <el-table-column prop="prevYearAmount" label="去年消费金额">
              </el-table-column>
              <el-table-column prop="allPoints" label="当前积分">
              </el-table-column>
              <el-table-column prop="state" label="状态">
                <template slot-scope="scope">
                  {{ scope.row.state === 0 ? "有效" : "无效" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click.stop="mergePreservation">确 定</el-button>
          <el-button @click="mergeVisible = false">取 消</el-button>
        </div>
        <div style="height: 30px; background-color: #ededed; line-height: 30px">
          <span style="margin-left: 20px; color: #6c6937">被合并会员</span>
        </div>
        <div style="margin: 0 20px 0 20px">
          <!-- 弹窗表单 -->
          <div style="width: 450px; margin-top: 10px">
            <el-form size="mini" label-width="200px" :model="formInline1">
              <el-form-item label="会员姓名\会员卡号\手机号">
                <div class="flex-between">
                  <el-input style="width: 300px" v-model="formInline1.serach">
                  </el-input>
                  <el-button
                    style="
                      width: 80px;
                      margin-left: 10px;
                      background-color: #f1f1f1;
                      color: #b6b388;
                    "
                    size="small"
                    icon="el-icon-search"
                    @click="onSubmit2"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 弹窗列表 -->
          <div style="width: 100%; margin-top: 10px">
            <el-table
              size="mini"
              height="200"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
                fontSize: '12px',
              }"
              :cell-style="{ 'text-align': 'center', fontSize: '10px' }"
              ref="multipleTable"
              :data="tableData2"
              tooltip-effect="dark"
            >
              <el-table-column label width="35">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.$index"
                    v-model="radio2"
                    @change.native="getCurrentRow2(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column prop="custName" label="顾客姓名">
              </el-table-column>
              <el-table-column prop="cardNo" label="会员卡号">
              </el-table-column>
              <el-table-column prop="levelName" label="顾客等级">
              </el-table-column>
              <el-table-column prop="mobile" label="移动电话">
              </el-table-column>
              <el-table-column prop="serviceOrgCode" label="维护店">
              </el-table-column>
              <el-table-column prop="serviceEmpCode" label="当前维护人">
              </el-table-column>
              <el-table-column prop="custType" label="会员类型">
                <template slot-scope="scope">
                  {{ scope.row.custType === 0 ? "非VIC会员" : "VIC会员" }}
                </template>
              </el-table-column>
              <el-table-column prop="lastSaleDate" label="最近购买日">
              </el-table-column>
              <el-table-column prop="currYearAmount" label="今年消费金额">
              </el-table-column>
              <el-table-column prop="prevYearAmount" label="去年消费金额">
              </el-table-column>
              <el-table-column prop="allPoints" label="当前积分">
              </el-table-column>
              <el-table-column prop="state" label="状态">
                <template slot-scope="scope">
                  {{ scope.row.state === 0 ? "有效" : "无效" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- table 表格 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form size="small" label-width="200px">
          <el-row :gutter="100">
            <el-col :span="8">
              <el-form-item label="会员(手机号\姓名\会员卡)">
                <el-input
                  v-model="config.search"
                  placeholder="请输入内容"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="centercard">
      <el-card shadow="never">
        <el-table
          border
          height="560px"
          size="small"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableList"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index"></el-table-column>
          <!-- <el-table-column label width="35">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radio2"
                @change.native="handleSelectionChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column> -->
          <el-table-column prop="custName" label="主卡姓名"> </el-table-column>
          <el-table-column prop="cardNo" label="主卡卡号"> </el-table-column>
          <el-table-column prop="subCardNo" label="副卡卡号"> </el-table-column>
          <el-table-column prop="subCustName" label="副卡姓名">
          </el-table-column>
          <el-table-column prop="sublevelName" label="副卡级别">
          </el-table-column>
          <el-table-column prop="subMobile" label="副卡手机号码">
          </el-table-column>
          <el-table-column prop="subRegistDate" label="副卡注册日期">
          </el-table-column>
          <el-table-column prop="subUpdateLvlDate" label="副卡最后升级日期">
            <template slot-scope="scope">
              <div v-if="scope.row.subUpdateLvlDate !== null">
                {{ scope.row.subUpdateLvlDate | dateFormat }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop="levelName" label="合并后级别">
          </el-table-column>
          <el-table-column prop="createDate" label="合并日期">
          </el-table-column>
          <el-table-column prop="createTime" label="合并时间">
          </el-table-column>
          <el-table-column prop="createEmpName" label="合卡人员">
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import { selectMainListApi, cardMergeApi, cardMergeListApi } from "@/api/user";

export default {
  name: "centre",
  data() {
    return {
      // radio: "",
      loading: true,
      mergeVisible: false,
      radio1: "",
      radio2: "",
      inputBtn: "",
      // 合并搜索
      config: {
        // 查询
        search: "",
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        pages: 0,
      },
      formInline: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        state: 0,
      },
      formInline1: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        state: 0,
      },
      tableList: [], // tableList
      tableData1: [], //弹窗上列表
      tableData2: [], //弹窗下列表
      templateSelection1: "",
      templateSelection2: "",
      jurisdiction: {
        search: false,
        merge: false,
      },
    };
  },
  computed: {
    isMore() {
      return this.config.pageNo >= this.config.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  created() {
    let Merge = JSON.parse(localStorage.getItem("Merge"));
    for (let i = 0; i < Merge.length; i++) {
      if (Merge[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Merge[i].menuName == "合并会员") {
        this.jurisdiction.merge = true;
        continue;
      }
    }
    this.allBableList();
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    mergeVisibleDialog() {
      this.mergeVisible = true;
      this.onSubmit1();
      this.onSubmit2();
    },
    // 搜索
    searchList() {
      this.loading = true;
      this.tableList = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.allBableList();
    },
    // 表格数据
    allBableList() {
      let formeData = {
        search: this.config.search,
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
      };
      cardMergeListApi(formeData).then((res) => {
        // console.log(res);
        if (res.message == "success") {
          if (this.config.pageNo == 1) this.tableList = [];
          this.tableList = this.tableList.concat(res.data.list);
          this.config.pages = res.data.pages;
          this.loading = false;
        }
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.allBableList();
      }, 500);
    },
    // 合并后---查询
    async onSubmit1() {
      const { data: res } = await selectMainListApi(
        require("qs").stringify(this.formInline)
      );
      this.tableData1 = res.list;
      console.log(this.tableData1);
    },
    async onSubmit2() {
      const { data: res } = await selectMainListApi(
        require("qs").stringify(this.formInline1)
      );
      this.tableData2 = res.list;
      console.log(this.tableData2);
    },
    // 合并选中的数据
    getCurrentRow1(row) {
      this.templateSelection1 = row.custID;
    },
    // 合并被选中的数据
    getCurrentRow2(row) {
      this.templateSelection2 = row.custID;
    },
    // 发起合并
    mergePreservation() {
      if (this.templateSelection1 !== "" && this.templateSelection2 !== "") {
        cardMergeApi({
          cpyNO: getcpyNo(),
          mainCustID: this.templateSelection1,
          subCustID: this.templateSelection2,
        }).then((res) => {
          if (res.success) {
            this.$message.success("合并成功!");
            this.mergeVisible = false;
            this.tableList = [];
            this.allBableList();
            this.radio1 = "";
            this.radio2 = "";
          }
        });
      } else {
        return this.$message.warning("请选择数据!");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#merge {
  // height: 1210px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5;
    color: #ffffff;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .merge {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 16px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 0 20px 0;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
